import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { notificationService } from '../services/notification-service';

const TestErrorNotifications = () => {
  const navigation = useNavigation();
  const testShortError = () => {
    notificationService.sendNotification('error', 'Short error message');
  };

  const testMediumError = () => {
    notificationService.sendNotification('error', 'This is a medium-length error message that should fit within the enhanced toast bounds but still demonstrate improved text wrapping capabilities.');
  };

  const testLongError = () => {
    notificationService.sendNotification('error', 'This is a very long error message that will be automatically truncated in the toast but will be expandable. When the user taps on this toast, they will see the full error message in a popup modal, providing a much better user experience for detailed error information.');
  };

  const testApiError = () => {
    notificationService.sendNotification('error', 
      'Invalid charger email. Please enter a valid email associated with your charger manufacturer.',
      'Invalid charger email. Please enter a valid email associated with your charger manufacturer. This error occurs when the email address provided does not match any registered charger in our partner portal. Please check that you have entered the correct email address that was provided when you purchased your charger. If you continue to have issues, please contact customer support with your charger serial number.'
    );
  };

  const testSuccessMessage = () => {
    notificationService.sendNotification('success', 'Operation completed successfully!');
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Test Error Notifications</Text>
      
      <TouchableOpacity style={styles.button} onPress={testShortError}>
        <Text style={styles.buttonText}>Short Error</Text>
      </TouchableOpacity>
      
      <TouchableOpacity style={styles.button} onPress={testMediumError}>
        <Text style={styles.buttonText}>Medium Error</Text>
      </TouchableOpacity>
      
      <TouchableOpacity style={styles.button} onPress={testLongError}>
        <Text style={styles.buttonText}>Long Error (Auto-expandable)</Text>
      </TouchableOpacity>
      
      <TouchableOpacity style={styles.button} onPress={testApiError}>
        <Text style={styles.buttonText}>API Error (Custom expandable)</Text>
      </TouchableOpacity>
      
      <TouchableOpacity style={[styles.button, styles.successButton]} onPress={testSuccessMessage}>
        <Text style={styles.buttonText}>Success Message</Text>
      </TouchableOpacity>
      
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 20,
    backgroundColor: '#1a1a1a',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FFFFFF',
    marginBottom: 20,
    textAlign: 'center',
  },
  button: {
    backgroundColor: '#F97777',
    padding: 15,
    borderRadius: 8,
    marginBottom: 10,
    alignItems: 'center',
  },
  successButton: {
    backgroundColor: '#51B868',
  },
  navigationButton: {
    backgroundColor: '#007AFF',
  },
  buttonText: {
    color: '#FFFFFF',
    fontWeight: '600',
    fontSize: 14,
  },
});

export default TestErrorNotifications;
